import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { CianSmall12, Label } from '@cian/ui-kit';
import * as React from 'react';

import { ELabelColor, ILabel } from '../../types/label';
import { GeneralInfoSectionRow } from '../GeneralInfoSectionRow';
import { LabelTooltip } from '../LabelTooltip';
import { mapLabelBgColor, mapLabelColor } from './mapColors';
import * as styles from './styles.css';

interface ILabelsListProps {
  labels: ILabel[];
  onShow: () => void;
}

export function LabelsList({ labels, onShow }: ILabelsListProps) {
  return (
    <GeneralInfoSectionRow>
      <ActionAfterViewObserver callback={onShow} triggerOnce={true}>
        <div className={styles['container']}>
          {labels.map((label, idx) => (
            <div className={styles['label']} key={idx}>
              <LabelTooltip tooltip={label.tooltip}>
                <Label
                  background={mapLabelBgColor(label.color)}
                  color={mapLabelColor(label.color)}
                  icon={label.color === ELabelColor.Blue ? <CianSmall12 color="current_color" /> : undefined}
                >
                  {label.text}
                </Label>
              </LabelTooltip>
            </div>
          ))}
        </div>
      </ActionAfterViewObserver>
    </GeneralInfoSectionRow>
  );
}
